"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PARSER_ACTION;
(function (PARSER_ACTION) {
    PARSER_ACTION[PARSER_ACTION["UNKNOWN"] = 0] = "UNKNOWN";
    PARSER_ACTION[PARSER_ACTION["UNKNOWN_TOPIC"] = 1] = "UNKNOWN_TOPIC";
    PARSER_ACTION[PARSER_ACTION["UNKNOWN_ACTION"] = 2] = "UNKNOWN_ACTION";
    PARSER_ACTION[PARSER_ACTION["INVALID_MESSAGE"] = 3] = "INVALID_MESSAGE";
    PARSER_ACTION[PARSER_ACTION["MESSAGE_PARSE_ERROR"] = 4] = "MESSAGE_PARSE_ERROR";
    PARSER_ACTION[PARSER_ACTION["MAXIMUM_MESSAGE_SIZE_EXCEEDED"] = 5] = "MAXIMUM_MESSAGE_SIZE_EXCEEDED";
    PARSER_ACTION[PARSER_ACTION["ERROR"] = 6] = "ERROR";
    PARSER_ACTION[PARSER_ACTION["INVALID_META_PARAMS"] = 7] = "INVALID_META_PARAMS";
})(PARSER_ACTION = exports.PARSER_ACTION || (exports.PARSER_ACTION = {}));
//# sourceMappingURL=parser.js.map